import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import NavbarMenu from "./components/NavbarMenu";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Intro        from "./pages/Intro";
import Home         from "./pages/Home";
import Greeting     from "./pages/Greeting";
import About        from "./pages/About";
import History      from "./pages/History";
import Products     from "./pages/Products";
import Tech         from "./pages/Tech";
import Resources    from "./pages/ResourcesList";
import Recruit      from "./pages/Recruit";
import Entry        from "./pages/Entry";
import Thanks       from "./pages/Thanks";
import Contact      from "./pages/Contact";
import ConfirmPage  from "./pages/ConfirmPage";
import CompletePage from "./pages/CompletePage";
import Policy       from "./pages/Policy";
import TermsOfUse from "./pages/TermsOfUse";
import TopicsList   from "./pages/TopicsList";
import TopicsDetail from "./pages/TopicsDetail";

function App() {
  const location = useLocation();

  // Intro 画面ではナビバーとフッターを非表示
  const isIntro = location.pathname === "/";

  return (
    <>
      {/* ページ遷移・ハッシュリンク時にスクロール位置をリセット */}
      <ScrollToTop />

      {!isIntro && <NavbarMenu />}

      <Routes>
        <Route path="/"               element={<Intro />} />
        <Route path="/home"           element={<Home />} />
        <Route path="/greeting"       element={<Greeting />} />
        <Route path="/about"          element={<About />} />
        <Route path="/history"        element={<History />} />
        <Route path="/products"       element={<Products />} />
        <Route path="/tech"           element={<Tech />} />
        <Route path="/resources"      element={<Resources />} />
        <Route path="/policy"         element={<Policy />} />
        <Route path="/termsofuse"     element={<TermsOfUse />} />
        <Route path="/topics"         element={<TopicsList />} />
        <Route path="/topics/:id"     element={<TopicsDetail />} />
        <Route path="/recruit"        element={<Recruit />} />
        <Route path="/entry"          element={<Entry />} />
        <Route path="/thanks"         element={<Thanks />} />
        <Route path="/contact"        element={<Contact />} />
        <Route path="/contact/confirm"  element={<ConfirmPage />} />
        <Route path="/contact/complete" element={<CompletePage />} />
      </Routes>

      {!isIntro && <Footer />}
    </>
  );
}

export default App;